import { render } from "./ControlPanelPhone.vue?vue&type=template&id=f4ed20ec&scoped=true"
import script from "./ControlPanelPhone.vue?vue&type=script&lang=js"
export * from "./ControlPanelPhone.vue?vue&type=script&lang=js"

import "./ControlPanelPhone.vue?vue&type=style&index=0&id=f4ed20ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4ed20ec"]])

export default __exports__